﻿export class UserData {
    userSurrKey: number = 0;
    userFullName: string = "";
}
